var exports = {
  "N": "x93eb46d8--faf7d1--on-map",
};

module.exports = exports;
